import { QueryOptions, FetchPolicy } from 'apollo-client';
import * as query from './query.gql';

export const currentUserQuery = (fetchPolicy: FetchPolicy = 'cache-first'): QueryOptions<{}> => ({
  query,
  fetchPolicy,
});
